(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layouthub_popup_banner"] && !window.DesignMode) return;
  try {
    
	 
	(()=>{
		const params = {"enabled":true,"pages":["home","collection"],"devices":["all"],"width":"1000","link":"https:\/\/touchaustralia.com.au\/collections\/general-health-and-wellness-test-self-testing"};
		function setCookie(cname, cvalue, exdays) {
			  var d = new Date();
			  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			  var expires = "expires="+d.toUTCString();
			  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			}

		function getCookie(cname) {
		  var name = cname + "=";
		  var ca = document.cookie.split(';');
		  for(var i = 0; i < ca.length; i++) {
		    var c = ca[i];
		    while (c.charAt(0) == ' ') {
		      c = c.substring(1);
		    }
		    if (c.indexOf(name) == 0) {
		      return c.substring(name.length, c.length);
		    }
		  }
		  return "";
		}
		function buildPopup()
		{
			if(document.querySelector('.lh-miniapps_popup_banner'))
			{
				return 1;
			}
			let container = document.createElement('div')
			container.classList.add('lh-miniapps_popup_banner');
			container.innerHTML = `<div class="lh-popup-bg"></div>`;
			let innner = document.createElement('div')
				innner.classList.add('lh-popup-banner-inner')
				innner.innerHTML = `
						<div class="lh-popup-stage">
							<div class="lh-popup-wrapper">
								<div class="lh-popup-content">
									<a href="https://touchaustralia.com.au/collections/general-health-and-wellness-test-self-testing" target="_blank">
										<img src="" alt="banner"/>
									</a>
								</div>
							</div>
						</div>
						<button class="lh-popup-banner-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button>
					`;
					
			container.appendChild(innner)
			document.body.appendChild(container)
			 let  outside = container.querySelector('.lh-popup-wrapper');
	            outside.addEventListener('click', function(e){  
	                if(e.target === this)
	                {
	                    closePopup();
	                }
	            });
		}
		
		function closePopup() {
		  setCookie("lh-popup-banner", 'yes', 30);
		  document.querySelector(".lh-miniapps_popup_banner").style.display = "none";
		  document.body.classList.remove('lh-popup-banner-opening')
		}
		function openPopup()
		{
			let dom = document.querySelector('.lh-miniapps_popup_banner');
			document.body.classList.add('lh-popup-banner-opening')
			if(dom)
			{
				dom.classList.add('lh-open');
			}
		}
		function init()
		{
			buildPopup();
			let cookie_bar = document.querySelector("#lh-popup-banner");
			if (cookie_bar) {
			  if (!getCookie("lh-popup-banner")) {
			  	let dom = document.querySelector('.lh-miniapps_popup_banner');
			  	let already = false;
			  	if(dom)
			  	{
			  		switch(params.when)
			  		{
			  			case 'delay':
			  				setTimeout(()=>{
			  					openPopup();
			  				}, params.delay ? params.delay * 1000 : 5000);
			  				break;
			  			case 'hover':
			  				let selector = params.hover;
			  				if(selector)
			  				{
                                if(window.jQuery)
                                {
                                    jQuery(selector).hover(function(){
                                         
                                        if(already) return ; 
                                        already = true;
                                        openPopup();
                                    });
                                }
                                else 
                                {
                                    hover.addEventListener('onmouseover',function(){
                                     
                                        if(already) return ; 
                                        already = true;
                                        openPopup();
                                    });
                                }
			  				}
			  				break;
			  			case 'close':
			  					document.addEventListener('mouseleave', function(){
			  						if(already) return ;
	  							 		already = true;
	  							 		openPopup();
			  					})
			  				break;
			  			default: 
			  				openPopup();
			  				break;
			  		}
			  	}
			    //If the cookie has not been set
			     
			  } 
			}
			let cookie_btn = document.querySelector('.lh-popup-banner-btn');
			if(cookie_btn)
			{
				cookie_btn.addEventListener('click', closePopup)
			}

		}
		let device = (window.screen.width < 768) ? 'mobile' : (window.screen.width < 992) ? 'tablet' : 'desktop';
		if(params.devices && (params.devices.includes('all')  || params.devices.includes(device)))
		{
			init();
		}

	})()

  } catch(e) { console.error(e); }
})();
})();
